import { render, staticRenderFns } from "./serviceDelivery.vue?vue&type=template&id=726f93d4&scoped=true&"
import script from "./serviceDelivery.vue?vue&type=script&lang=js&"
export * from "./serviceDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726f93d4",
  null
  
)

export default component.exports